import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  standalone: false,
  template: `<a *ngIf="environmentId" href="#{{url}}">{{environmentId}}</a>`
})
export class EnvironmentLinkCellComponent implements ICellRendererAngularComp {

  url: any;
  environmentId: any;

  constructor(private router: Router) {}

  agInit(params: any): void {
    this.url = this.router.createUrlTree(['erm/environments', params.value]);
    this.environmentId = params.value;
  }

  refresh(): boolean {
    return false;
  }
}
